module.exports = __webpack_public_path__ + "static/full01-72f42ebffda5fa4553dbd61dd8cfb1aa.png";